import {Component, Input} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import { PremiesKindComponent } from './premies-kind/premies-kind.component';
import { PremiesAnwComponent } from './premies-anw/premies-anw.component';
import { PremiesAovComponent } from './premies-aov/premies-aov.component';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overige-premies',
  templateUrl: './overige-premies.component.html',
  styleUrls: ['./overige-premies.component.scss'],
  imports: [
    PremiesKindComponent,
    PremiesAnwComponent,
    PremiesAovComponent
  ]
})
export class OverigePremiesComponent {

    @Input() partner = new BehaviorSubject<boolean>(false);

}
